import router from '@/router'
import { removeToken } from '@/utils/auth'

/** 清除本地登录态 */
export function clearLoginState() {
  removeToken()
  localStorage.removeItem('token')
  localStorage.removeItem('userId')
  localStorage.removeItem('userInfos')
  sessionStorage.removeItem('token')
  sessionStorage.removeItem('userId')
  sessionStorage.removeItem('userInfos')
}

/** 跳转到登录页（先清 token，再用路由跳转，失败则硬跳转） */
export function goToLogin() {
  clearLoginState()
  router.push({ path: '/login' }).catch(() => {
    const base = process.env.BASE_URL || '/'
    const loginPath = `${base.replace(/\/?$/, '/')}login`
    window.location.href = loginPath
  })
}
